<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-app>
        <v-main>
            <snackbar/>
            <router-view v-show="!routing"/>
        </v-main>
    </v-app>
</template>

<script>
    import { mapState } from 'vuex'
    import Snackbar from '@/components/snackbar'

    export default
    {
        name: 'App',
        computed: mapState(['routing']),
        components:
        {
            Snackbar
        }
    }
</script>